import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts.js';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  importFile: null,
  importJsonData: null,

  checkImportFileStatus: IDLE,
  executeImportStatus: IDLE,

  downloadImportTemplateStatus: IDLE,
  exportRisksAndPoliciesFileStatus: IDLE
};

const importSlice = createSlice({
  name: 'import',
  initialState,
  reducers: {
    setImportFile(state, action) {
      state.importFile = action.payload.file;
    },

    clearImportFile(state) {
      state.importFile = null;
      state.importJsonData = null;
      state.checkImportFileStatus = IDLE;
      state.executeImportStatus = IDLE;
    },

    checkImportFile(state) {
      state.importJsonData = null;
      state.checkImportFileStatus = LOADING;
    },
    checkImportFileSucceeded(state, action) {
      state.importJsonData = action.payload;
      state.checkImportFileStatus = SUCCEEDED;
    },
    checkImportFileFailed(state) {
      state.checkImportFileStatus = FAILED;
    },

    executeImport(state) {
      state.executeImportStatus = LOADING;
    },
    executeImportSucceeded(state) {
      state.executeImportStatus = SUCCEEDED;
    },
    executeImportFailed(state) {
      state.executeImportStatus = FAILED;
    },

    downloadImportTemplate(state) {
      state.downloadImportTemplateStatus = LOADING;
    },
    downloadImportTemplateSucceeded(state) {
      state.downloadImportTemplateStatus = SUCCEEDED;
    },
    downloadImportTemplateFailed(state) {
      state.downloadImportTemplateStatus = FAILED;
    },

    exportRisksAndPoliciesExportFile(state) {
      state.exportRisksAndPoliciesFileStatus = LOADING;
    },
    exportRisksAndPoliciesExportFileSucceeded(state) {
      state.exportRisksAndPoliciesFileStatus = SUCCEEDED;
    },
    exportRisksAndPoliciesExportFileFailed(state) {
      state.exportRisksAndPoliciesFileStatus = FAILED;
    }
  }
});

export const {
  setImportFile,
  clearImportFile,
  checkImportFile,
  checkImportFileSucceeded,
  checkImportFileFailed,
  executeImport,
  executeImportSucceeded,
  executeImportFailed,
  downloadImportTemplate,
  downloadImportTemplateSucceeded,
  downloadImportTemplateFailed,
  exportRisksAndPoliciesExportFile,
  exportRisksAndPoliciesExportFileSucceeded,
  exportRisksAndPoliciesExportFileFailed
} = importSlice.actions;

export default importSlice.reducer;
